export default {
    IMAGE: {
        element: function () {
            return `<img 
                alt="chat-image" 
                style = ${this.style}
                src = ${this.src} 
            />`
        },
        src: '',
        style: 'position:absolute;' +
                'top:50%;' +
                'left:50%;' +
                'transform:translate(-50%,-50%);' +
                'width:auto;' +
                'height:auto;' +
                'max-width:90%;' +
                'max-height:90% ',
        setSrc: function(src) {
            this.src = src
        } 
    },
    VIDEO: {
        element: function() {
            return `<video 
                style = ${this.style}
                src = ${this.src}
                muted
                autoplay
                controls 
                disablepictureinpicture 
                controlslist="nodownload noplaybackrate"
                > 
                </video>`
        },
        src: '',
        style: 'position:absolute;' +
                'top:50%;' +
                'left:50%;' +
                'transform:translate(-50%,-50%);' +
                'width:auto;' +
                'height:auto;' +
                'max-width:90%;' +
                'max-height:90% ',
        setSrc: function(src) {
            this.src = src
        } 
    }
}